<template>
  <Layout>
    <b-modal
        id="modalUpload"
        scrollable
        title="Subir archivo"
        title-class="font-18"
        size="lg"
        no-close-on-esc
        hide-footer
        centered
    >
      <subirArchivos v-on:upload-complete="uploadComplete" />
    </b-modal>
    <b-modal
        id="modalEntrada"
        scrollable
        title="Entrada a almacen"
        title-class="font-24"
        size="xl"
        hide-footer
    >
      <b-overlay :show="isLoadingModal" rounded="sm">
        <form class="needs-validation" @submit.prevent="submitEntrada">
        <b-tabs  card >
          <b-tab title="Datos" active>
              <div class="row">
                  <div class="form-group col-md-9">
                    <label>Expediente</label>
                    <v-select
                        :options="expedientes"
                        label="obra_expediente"
                        :reduce="desc=>desc.expediente_id"
                        v-model="model.expediente_id"
                        :class="{ 'is-invalid': submittedGastos && $v.model.expediente_id.$error }"
                        @input="cargarMetas()"
                        :disabled="deshabilitar_formulario"
                    />
                    <div v-if="submittedGastos && $v.model.expediente_id.$error" class="invalid-feedback">
                      <span v-if="!$v.model.expediente_id.required">Este valor es requerido.</span>
                    </div>
                  </div>
                  <div class="form-group col-md-3">
                    <label>Fecha</label>
                    <VueCtkDateTimePicker
                        v-model="model.fecha"
                        :locale="'es'"
                        :input-size="'sm'"
                        :format="'YYYY-MM-DD'"
                        :formatted="'YYYY-MM-DD'"
                        :range="false"
                        :auto-close="true"
                        :only-date="true"
                        :no-header="true"
                        :class="{ 'is-invalid': submittedGastos && $v.model.fecha.$error }"
                        style="z-index: 100"
                        :disabled="deshabilitar_formulario"
                    />
                    <!--style="position: fixed;width: 180px-->
                    <!--:class="{ 'is-invalid': submittedModificarPartida && $v.partida_modificar.fecha.$error }"-->
                    <div v-if="submittedGastos && $v.model.fecha.$error" class="invalid-feedback">
                      <span v-if="!$v.model.fecha.required">Este valor es requerido.</span>
                    </div>
                  </div>
              </div>
              <div class="row">

                <div class="form-group col-md-3">
                  <label>Tipo de entrada</label>
                  <select
                      class="form-control"
                      v-model="model.tipo"
                      :class="{ 'is-invalid': submittedGastos && $v.model.tipo.$error }"
                      :disabled="deshabilitar_formulario"
                  >
                    <option value="20">Orden de compra</option>
                    <option value="30">NEA (Nota de entrada de almacen) </option>
                    <option value="300">Otros</option>
                  </select>
                  <div v-if="submittedGastos && $v.model.tipo.$error" class="invalid-feedback">
                    <span v-if="!$v.model.tipo.required">Este valor es requerido.</span>
                  </div>
                </div>
                <div class="form-group col-md-3">
                  <label>Número</label>
                  <div class="input-group mb-3">
                    <input type="text" class="form-control"
                           placeholder="Ingrese el número"
                           aria-describedby="button-addon2"
                           v-model="model.numero_documento"
                           :disabled="deshabilitar_formulario"
                    >
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary"
                              type="button"
                              id="button-addon2"
                              v-on:click="buscarDocumento"
                              :disabled="deshabilitar_formulario"
                      >
                        <i class="fa fa-search"></i>
                        Buscar
                        <b-spinner small v-show="loadingDocumento"></b-spinner>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-3">
                  <label>Pecosa</label>
                  <input type="text"
                         class="form-control"
                         v-model="model.pecosa"

                  />

                </div>
              </div>

            <h4>Lista</h4>
            <div class="row">
              <table class="table table-bordered">
                <thead>
                <tr>
                  <th>ID</th>
                  <th>Nombre</th>
                  <th>UdM</th>
                  <th>Cantidad global</th>
                  <!--<th>C.U.</th>
                  <th>Subtotal</th>-->
                  <th>Cantidad parcial entregada</th>
                  <th>Cantidad a entregar</th>
                  <th>Cantidad recibida actual </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in model.detalles"  v-bind:key="index">
                  <td>{{data.id}}</td>
                  <td>{{data.nombre}}</td>
                  <td>{{data.unidad_medida}}</td>
                  <td>{{data.cantidad_global}}</td>
                  <!--<td>{{data.precio_unitario}}</td>
                  <td>{{data.subtotal}}</td>-->
                  <td>{{data.cantidad_parcial_recibida}}</td>
                  <td>{{data.cantidad_a_entregar}}</td>
                  <td>
                    <input class="form-control" v-model="data.cantidad"    :disabled="deshabilitar_formulario" readonly>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </b-tab>
          <b-tab title="Documentos">

            <div class="form-row">
              <div class="form-group col-md-3">
                <label>Documento</label>
                <select class="form-control" v-model="documento_tipo_subir" >
                  <!--<option value="10">Orden de servicio</option>-->
                  <!--<option value="20">Orden de compra</option>-->
                  <option value="30">Comprobante de pago</option>
                  <option value="40">Pecosa</option>
                  <option value="50">Guía de remisión</option>
                  <!--<option value="60">Conformidad</option>-->
                  <!--<option value="70">Hoja de tareo</option>-->
                  <!--<option value="80">Documento de habilitación</option>-->
                  <!--<option value="90">Documento de rendición</option>-->
                </select>
              </div>
              <div class="form-group col-md-3">
                <button type="button" class="btn btn-outline-primary mt-4" v-show="$can('gastos-modificar')" v-on:click="abrirCarga">Cargar documento</button>
              </div>

            </div>


            <div class="row font-size-12">
              <table class="table">
                <thead>
                <th>ID</th>
                <th>Tipo documento</th>
                <th>Nombre original</th>
                <th>Tamaño</th>
                <th>Op</th>
                </thead>
                <tbody>
                <tr v-for="(data,index) in model.archivos"  v-bind:key="index">
                  <td>
                    {{ data.id }}
                  </td>
                  <td>{{data.documento_tipo_str}}</td>

                  <td>
                    <a :href="server + '/storage/' + data.nombre"  target="_blank" >
                      {{data.nombre_original}}
                    </a>

                  </td>
                  <td>{{formatSize(data.size) }} MB</td>
                  <td>
                    <button
                        v-show="$can('am-entrada-modificar')"
                        class="btn btn-danger btn-icon btn-sm ml-1"
                        type="button"
                        v-on:click="borrarArchivo(data.id)" >
                      <i class="fa fa-trash"></i>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>

            </div>
          </b-tab>
        </b-tabs>
        <div class="row">
          <div class="col-md-12 text-right">
            <button class="btn btn-primary mr-2" type="submit" :disabled="deshabilitar_formulario">
              <i class="fa fa-save"></i>
              Guardar y mover al almacen</button>
            <button class="btn btn-outline-secondary"
                    type="button"
                    v-on:click="cerrarFormulario"
            >
              <i class="fa fa-door-closed"></i>
              Salir</button>
          </div>
        </div>
        </form>
      </b-overlay>
    </b-modal>

    <PageHeader :title="title" :items="items" />
    <button  type="button" class="btn btn-primary mb-3" v-on:click="nuevo">Nuevo</button>
    <div class="row">
      <div class="form-group col-md-12">
        <label>Expediente</label>
        <v-select
            :options="expedientes"
            label="obra_expediente"
            :reduce="desc=>desc.expediente_id"
            v-model="expediente_id"
            @input="loadItems()"
        />
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-12">
        <label>Buscar</label>
        <div class="input-group">
          <input
              type="text"
              v-model="terminoBusqueda"
              class="form-control"
              placeholder="Buscar por numero de pecosa,recurso"
              @input="buscarPorTermino"
          >
          <!--<div class="input-group-append">
            <button class="input-group-text" v-on:click="loadItems" >Buscar</button>
            <button class="input-group-text" v-on:click="loadItems" >Borrar</button>
          </div>-->
        </div>
      </div>
    </div>
    <vue-good-table
        ref="tabla"
        mode="remote"
        @on-page-change="onPageChange"
        @on-sort-change="onSortChange"
        @on-column-filter="onColumnFilter"
        @on-per-page-change="onPerPageChange"
        @on-search="onSearch"
        :totalRows="totalRecords"
        :isLoading.sync="isLoading"
        :pagination-options="{
              enabled: true,
              }"
        :rows="rows"
        :columns="columns"

        styleClass="vgt-table striped smalltable"

    >
      <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'acciones'">
              <button class="btn btn-success btn-icon btn-sm mr-1"
                      v-on:click="ver(props.row.id)"
                      v-show="$can('am-entrada-ver')"
              ><i class="fa fa-eye"></i></button>
              <button class="btn btn-primary btn-icon btn-sm mr-1"
                      v-on:click="ver(props.row.id)"
                      v-show="$can('am-entrada-ver')"
              ><i class="fa fa-print"></i></button>

              <!--<button class="btn btn-primary btn-icon btn-sm" v-on:click="modificar(props.row.id)"><i class="fa fa-edit"></i></button>-->
              <button class="btn btn-danger btn-icon btn-sm ml-1" v-on:click="borrar(props.row.id)"><i class="fa fa-trash"></i></button>

            </span>
        <span v-else>
              {{props.formattedRow[props.column.field]}}
        </span>
      </template>
    </vue-good-table>
  </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {required} from "vuelidate/lib/validators";
import subirArchivos from "@/components/subir-archivos.vue";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Entradas a almacen",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {
    subirArchivos,
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Entradas a almacen",
      items: [
        {
          text: "Finanzas",
          href: "/",
        },
        {
          text: "Pagos",
          active: true,
        },
      ],

      isLoading: false,
      columns: [
        {
          label: 'id',
          field: 'id',
        },
        {
          label: 'Pecosa',
          field: 'pecosa',
        },
        {
          label: 'Recursos',
          field: 'recursos',
        },
        {
          label: 'Tipo',
          field: 'tipo_str',
        },
        {
          label: 'Fecha',
          field: 'fecha',
        },
        {
          label: 'Usuario',
          field: 'usuario',
        },
        {
          label: 'Acciones',
          field: 'acciones',
          width: '15%'
        }
      ],
      rows: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: '',
          type: '',
        },
        page: 1,
        perPage: 10
      },
      isLoadingModal:false,
      disable_monto:false,
      disable_ruc:false,
      disable_denominacion:false,
      disable_clasificador:false,
      submittedGastos:false,
      model:{
        id:0,
        expediente_id:null,
        tipo:null,
        detalles:[]
      },
      expedientes:[],
      server:process.env.VUE_APP_BACKEND,
      loadingDocumento:false,
      recurso_actual:{},
      unidades_medida:[],
      deshabilitar_formulario:false,
      documento_tipo_subir:null,
      terminoBusqueda:"",
      expediente_id:null
    };
  },

  methods: {
    buscarPorTermino(){
      clearTimeout(this.debounceTimer);
      // Establecer un nuevo temporizador de medio segundo
      this.debounceTimer = setTimeout(() => {
        this.serverParams.page=1;
        this.$refs['tabla'].reset();
        //this.$refs['tabla'].reset();
        this.loadItems();
        // Aquí puedes realizar las acciones que necesites
      }, 500); //
    },
    formatSize(bytes){
      return this.$formatSize(bytes);
    },
    agregarDetalle(){
      let recurso_id=null
      if(typeof this.recurso_actual.recurso_id!='undefined'){
        recurso_id=this.recurso_actual.recurso_id;
      }
      this.model.detalles.push({
        'recurso_id':recurso_id,
        'nombre':this.recurso_actual.nombre,
        'cantidad':this.recurso_actual.cantidad,
        'unidad_medida':this.recurso_actual.unidad_medida.nombre,
        'unidad_medida_id':this.recurso_actual.unidad_medida.id,
        'subtotal':this.recurso_actual.subtotal,
        'clasificador':this.recurso_actual.clasificador.nombre,
        'clasificador_id':this.recurso_actual.clasificador.id,
      })
    },
    cerrarFormulario(){
      this.$bvModal.hide("modalEntrada");
    },
    borrarDetalle(){

    },
    cargarMetas(){
      this.$cargarMetas(
          this.model.expediente_id,
           (res)=>{
             this.metas=res.data;
           },
      {}
      )
    },
    buscarDocumento(){
      if(this.model.expediente_id==null){
        this.$swal('Cuidado!',"Seleccione un expediente",'warning');
        return;
      }
      if(!this.$isNumeric(this.model.numero_documento)){
        this.$swal('Cuidado!',"Solo se acepta numeros",'warning');
        return;
      }
      if(parseInt(this.model.tipo)==20){
        this.isLoadingModal=true;
        this.axios.get(process.env.VUE_APP_BACKEND+"/api/orden-compra/buscar/"+this.model.numero_documento)
            .then((response)=>{
              this.model.detalles=response.data.detalles;
              this.model.detalles.forEach((item)=>{
                item.cantidad_global=item.cantidad;
                //item.cantidad=item.cantidad;
              })
            })
            .catch(()=>{
              this.$swal('Cuidado',"Error cargando la orden de compra",'warning');
            })
            .finally(()=>{
              this.isLoadingModal=false;
            })

      }
      else {
        this.$swal('Cuidado',"No implementado",'warning');
      }
    },
    uploadComplete(files){
      this.isLoading=true;
      this.$bvModal.hide("modalUpload");
      //files[0]['documento_tipo']=this.documento_tipo_subir;
      //this.gasto.archivos.push(files[0]);
      this.axios.post(process.env.VUE_APP_BACKEND + "/api/almacen/entradas/archivos",
          {
            files:files,
            documento_tipo:this.documento_tipo_subir,
            entrada_id:this.model.id
          })
          .then(()=>{
            //this.gasto=response.data.model;
            this.$bvModal.hide("modalUpload");
            this.actualizar();
          })
          .finally(()=>this.isLoading=false)
    },
    actualizar(){
      this.isLoadingModal=true;
      this.axios.get(process.env.VUE_APP_BACKEND + "/api/almacen/entradas/"+this.model.id)
          .then((response)=>{
            this.model=response.data;
            //this.$bvModal.show("modalEntrada");
            //this.loadItems();
            //this.actualizar();
          })
          .catch(()=>{
            this.$swal('Cuidado',"Error",'warning');
          })
          .finally(()=>this.isLoadingModal=false)
    },
    abrirCarga(){
      this.$bvModal.show("modalUpload");
    },
    submitEntrada(){
      this.submittedGastos = true;
      // stop here if form is invalid
      //this.$v.$touch();
      this.$v.model.$touch();
      if(this.$v.model.$error===false){
        this.guardar();
      }
      else
      {
        this.$swal('Cuidado',"Formulario no valido",'warning');
      }
    },
    nuevo(){
      this.deshabilitar_formulario=false;
      this.submittedGastos=false;
      this.model={
        id:0,
        expediente_id:null,
        meta_id:null,
        clasificador_id:null,
        archivos:[]
      };
      this.$bvModal.show("modalEntrada");

    },
    ver(id){
      this.isLoading=true;
      this.recurso_actual={};
      this.deshabilitar_formulario=true;
      this.axios.get(process.env.VUE_APP_BACKEND + "/api/almacen/entradas/"+id)
          .then((response)=>{
            this.model=response.data;
            this.metas=response.data.metas;
            this.$bvModal.show("modalEntrada");
            //this.loadItems();
            //this.actualizar();
          })
          .catch(()=>{
            this.$swal('Cuidado',"Error",'warning');
          })
          .finally(()=>this.isLoading=false)
    },
    modificar(id){
      this.isLoading=true;
      this.recurso_actual={};
      this.deshabilitar_formulario=false;
      this.axios.get(process.env.VUE_APP_BACKEND + "/api/almacen/entradas/"+id)
          .then((response)=>{
            this.model=response.data;
            this.metas=response.data.metas;
            this.$bvModal.show("modalEntrada");
            //this.loadItems();
            //this.actualizar();
          })
          .catch(()=>{
            this.$swal('Cuidado',"Error",'warning');
          })
          .finally(()=>this.isLoading=false)
    },
    guardar(){
      this.isLoadingModal = true;
      const request = this.model.id != 0
          ? this.axios.put(`${process.env.VUE_APP_BACKEND}/api/almacen/entradas/${this.model.id}`, this.model)
          : this.axios.post(`${process.env.VUE_APP_BACKEND}/api/almacen/entradas`, this.model);
      request
          .then(() => {
            this.$bvModal.hide("modalEntrada");
            this.loadItems();
            //this.actualizar();
          })
          .catch((r) => {
            this.$swal('Cuidado',r.response.data.mensaje,'warning');
            //this.$swal('Cuidado', "Error", 'warning');
          })
          .finally(() => {
            this.isLoadingModal = false;
          });

    },
    decimal(value) {
      if (value === null) {
        return '-'
      } else {
        return parseFloat(value).toFixed(2)
      }
    },
    borrarArchivo(id){
      this.$swal.fire({
        title: '¿Esta seguro de borrar el archivo?',
        text: "No se puede revertir esta accion!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Si, borralo!'
      }).then((result) => {
        if (result.value) {
          this.isLoadingModal=true;
          this.axios.delete(process.env.VUE_APP_BACKEND +'/api/almacen/entradas/'+this.model.id+'/archivos/'+id)
              .catch(()=>{
                this.$swal('error','Error eliminando','error');
              })
              .finally(
                  ()=>
                  {
                    this.isLoadingModal=false;
                    this.actualizar();
                  }

              );
        }
      })
    },
    borrar(id) {
      this.$swal.fire({
        title: '¿Esta seguro?',
        text: "No se puede revertir esta accion!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Si, borralo!'
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.axios.delete(process.env.VUE_APP_BACKEND + '/api/almacen/entradas/' + id)
              .catch(() => {
                this.$swal('error', 'Error eliminando', 'error');
              })
              .finally(
                  () => {
                    this.isLoading = false;
                    this.loadItems();
                  }
              );
        }
      })

    },
    onSearch: function (params) {
      this.updateParams({page: params.page});
      this.updateParams({searchTerm: params.searchTerm});
      this.loadItems();
    },
    say: function (message) {
      alert(message)
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.loadItems();
    },

    onPerPageChange(params) {
      this.updateParams({perPage: params.currentPerPage});
      this.loadItems();
    },

    onSortChange(params) {
      this.updateParams({
        sort: [{
          type: params.sortType,
          field: this.columns[params.columnIndex].field,
        }],
      });
      this.loadItems();
    },
    onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },
    // load items is what brings back the rows from server
    loadItems() {
      this.isLoading = true;
      this.serverParams.terminoBusqueda=this.terminoBusqueda;
      this.serverParams.expediente_id=this.expediente_id;
      this.axios.get(process.env.VUE_APP_BACKEND + '/api/almacen/entradas/tabla', {'params': this.serverParams})
          .then((response) => {
            //console.log(response.data.data);
            this.totalRecords = response.data.total_records;
            this.rows = response.data.data;
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
            //console.log(error);
          });
    },

  },
  mounted() {
    //this.loadItems();
    this.$cargarExpedientes( (res)=>{
      this.expedientes=res.data
      if(this.expedientes.length>0){
        this.expediente_id=this.expedientes[0].expediente_id;
        this.loadItems();
        //this.actualizar();
      }
    },()=>{});

    this.$cargarClasificadores( (res)=>{
      this.clasificadores=res.data
    },()=>{});
    this.$cargarUnidadesMedida( (res)=>{
      this.unidades_medida=res.data
    },()=>{});
  },
  validations: {
    model:{
      expediente_id:{required},
      fecha:{required},
      tipo:{required},
      numero_documento:{required}
    },

  },
};
</script>

<style>
.smalltable {
  font-size: 12px !important;
}
</style>
